export default __webpack_public_path__ + "static/media/BIA_seal_500x828.e648ec36.webp";